var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.504 6.14606C13.6987 5.95131 14.0145 5.95131 14.2092 6.14606L15.7052 7.64209C15.9 7.83683 15.9 8.15258 15.7052 8.34732L14.2092 9.84335C14.0145 10.0381 13.6987 10.0381 13.504 9.84335C13.3092 9.6486 13.3092 9.33286 13.504 9.13811L14.6474 7.9947L13.504 6.85129C13.3092 6.65655 13.3092 6.3408 13.504 6.14606Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99057 7.4961L7.99205 7.49609H14.4748C14.7503 7.49609 14.9735 7.71936 14.9735 7.99477C14.9735 8.27018 14.7503 8.49345 14.4748 8.49345H7.99284C7.46416 8.49521 6.95762 8.70601 6.58377 9.07986C6.20992 9.45371 5.99912 9.96025 5.99735 10.4889V10.9868C5.99735 11.2622 5.77409 11.4855 5.49868 11.4855C5.22326 11.4855 5 11.2622 5 10.9868V10.4881L5 10.4867C5.00237 9.69424 5.31821 8.93495 5.87853 8.37463C6.43886 7.8143 7.19815 7.49846 7.99057 7.4961Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97427 13.9893C10.169 14.1841 10.169 14.4998 9.97427 14.6946L8.83086 15.838L9.97427 16.9814C10.169 17.1761 10.169 17.4919 9.97427 17.6866C9.77953 17.8814 9.46378 17.8814 9.26904 17.6866L7.77301 16.1906C7.57827 15.9958 7.57827 15.6801 7.77301 15.4853L9.26904 13.9893C9.46378 13.7946 9.77953 13.7946 9.97427 13.9893Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1687 12.3472C18.4441 12.3472 18.6674 12.5704 18.6674 12.8458V13.3445L18.6674 13.346C18.665 14.1384 18.3492 14.8977 17.7888 15.458C17.2285 16.0184 16.4692 16.3342 15.6768 16.3366L15.6753 16.3366H9.19252C8.91711 16.3366 8.69385 16.1133 8.69385 15.8379C8.69385 15.5625 8.91711 15.3392 9.19252 15.3392H15.6745C16.2032 15.3375 16.7097 15.1267 17.0836 14.7528C17.4575 14.3789 17.6683 13.8724 17.67 13.3436V12.8458C17.67 12.5704 17.8933 12.3472 18.1687 12.3472Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundTrip);
export default __webpack_public_path__ + "static/media/roundTrip.470d0dd24b4e764a66d52467d1fc872d.svg";
export { ForwardRef as ReactComponent };